import { render, staticRenderFns } from "./PastServicesTable.vue?vue&type=template&id=0562d568"
import script from "./PastServicesTable.vue?vue&type=script&lang=js"
export * from "./PastServicesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports